<h1 mat-dialog-title>Solicitar cambio de horario</h1>

<mat-dialog-content>
  <mat-label>Motivo</mat-label>
  <mat-form-field appearance="outline" class="reason-field">
    <textarea matInput [formControl]="reason" rows="4" placeholder="Explica por qué necesitas este cambio de horario"></textarea>
    <mat-hint align="end">{{ reason.value.length }} / {{ min_length }} mín.</mat-hint>
    @if (reason.hasError('required') && (reason.touched || reason.dirty)) {
      <mat-error>El motivo es obligatorio</mat-error>
    } @else if (reason.hasError('minlength') && (reason.touched || reason.dirty)) {
      <mat-error>El motivo debe tener al menos {{ min_length }} caracteres</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="confirm()" [disabled]="reason.invalid">Solicitar</button>
</mat-dialog-actions>
